import { render, staticRenderFns } from "./MemberDocuments.vue?vue&type=template&id=b4615010&"
import script from "./MemberDocuments.vue?vue&type=script&lang=js&"
export * from "./MemberDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4615010')) {
      api.createRecord('b4615010', component.options)
    } else {
      api.reload('b4615010', component.options)
    }
    module.hot.accept("./MemberDocuments.vue?vue&type=template&id=b4615010&", function () {
      api.rerender('b4615010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/library/MemberDocuments.vue"
export default component.exports